import React, { useState, useEffect } from "react";
import Select from "react-select";

const options = [
  { label: "احدث المشاريع", value: "latest_projects" }, // Good practice: use English/Slugs for values
  { label: "قصص إنسانية", value: "human_stories" },
  { label: "الحملات", value: "campaigns" },
  { label: "مواسم الخير", value: "goodness_seasons" },
];

export default function CustomMultiSelect({ onChange }) {
  const [selected, setSelected] = useState([]);

  // Sync with parent whenever selection changes
  useEffect(() => {
    // react-select returns the full objects, so we map to just values for your API
    const values = selected ? selected.map((item) => item.value) : [];
    onChange(values);
  }, [selected, onChange]);

  return (
    <div className="p-2" dir="rtl">
      <Select
        isMulti
        name="categories"
        options={options}
        value={selected}
        onChange={setSelected}
        placeholder="اختر التصنيفات..."
        noOptionsMessage={() => "لا توجد خيارات"}
        className="text-right text-sm"
        // RTL Support for react-select
        isRtl={true}
        // Tailwind-friendly styling adjustments
        styles={{
          control: (base) => ({
            ...base,
            borderRadius: "0.5rem",
            borderColor: "#d1d5db", // gray-300
            padding: "2px",
            boxShadow: "none",
            "&:hover": {
              borderColor: "#3b82f6", // blue-500
            },
          }),
          multiValue: (base) => ({
            ...base,
            backgroundColor: "#eff6ff", // blue-50
            borderRadius: "0.375rem",
          }),
          multiValueLabel: (base) => ({
            ...base,
            color: "#1e40af", // blue-800
          }),
          multiValueRemove: (base) => ({
            ...base,
            color: "#3b82f6",
            "&:hover": {
              backgroundColor: "#dbeafe",
              color: "#1d4ed8",
            },
          }),
        }}
      />
    </div>
  );
}
